import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { EditProfileForm } from './EditProfileForm/EditProfileForm';
import { useEditProfilePopupPresenter } from './EditProfilePopup.presenter';
import styles from './EditProfilePopup.styles.m.css';

export const EditProfilePopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useEditProfilePopupPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      title={t('user_profile_update_header')}
      isOpened
      isHidden={props.popupInstance.isHidden}
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
      className={styles.formContainer}
    >
      <EditProfileForm submit={presenter.submit} />
    </Popup>
  );
});
